export interface ICryptoDappersTierList {
  [key: string]: string
}
export const CryptoDappersTierList: ICryptoDappersTierList = {
  '6': 'Common',
  '5': 'Uncommon',
  '4': 'Rare',
  '3': 'Epic',
  '2': 'Legendary',
  '1': 'Mythic',
  '0': 'Spectral'
}
